import React, { useMemo, useState } from 'react';
import { Button, NumberInput, Tag, TextInput, Toggle } from '@carbon/react';

const ComplianceRecordSettings: React.FC = () => {
  const [channels, setChannels] = useState<string[]>(['News', 'Sports', 'Weather']);
  const [newChannel, setNewChannel] = useState('');
  const [alwaysOn, setAlwaysOn] = useState(true);
  const [retentionDays, setRetentionDays] = useState(30);
  const [segmentMinutes, setSegmentMinutes] = useState(60);

  const sortedChannels = useMemo(() => [...channels].sort(), [channels]);

  const handleAddChannel = () => {
    const value = newChannel.trim();
    if (!value) return;
    if (channels.includes(value)) {
      setNewChannel('');
      return;
    }
    setChannels(prev => [...prev, value]);
    setNewChannel('');
  };

  const handleRemoveChannel = (name: string) => {
    setChannels(prev => prev.filter(ch => ch !== name));
  };

  return (
    <>
      {/* <p className="settings-page__tab-copy">
        Manage which channels are tracked in Compliance Record and how continuous recording behaves.
      </p> */}

      <div className="settings-page__dual-panel">
        {/* <div className="settings-page__list-panel settings-page__list-panel--primary"> */}
          {/* <div className="settings-page__panel-header">
            <div>
              <h3>Channels</h3>
              <p>Add or remove channels that appear in Compliance Record.</p>
            </div>
          </div> */}

          {/* <div className="settings-page__form-grid">
            <TextInput
              id="compliance-channel-input"
              labelText="Channel name"
              placeholder="News HD"
              value={newChannel}
              onChange={e => setNewChannel(e.target.value)}
            />
            <Button onClick={handleAddChannel} disabled={!newChannel.trim()} style={{ alignSelf: 'flex-end' }}>
              Add channel
            </Button>
          </div> */}

          {/* <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {sortedChannels.length === 0 && <span className="settings-page__table-empty">No channels added yet.</span>}
            {sortedChannels.map(name => (
              <Tag
                key={name}
                filter
                title={`Remove ${name}`}
                onClose={() => handleRemoveChannel(name)}
              >
                {name}
              </Tag>
            ))}
          </div> */}
        {/* </div> */}

        <div className="settings-page__list-panel">
          <div className="settings-page__panel-header">
            <div>
              <h3>Recording Settings</h3>
              <p>Control continuous capture and retention for compliance feeds.</p>
            </div>
          </div>

          <div className="settings-page__form-grid">
            <Toggle
              id="compliance-247-toggle"
              labelText="Always on"
              labelA="Disabled"
              labelB="Enabled"
              toggled={alwaysOn}
              onToggle={setAlwaysOn}
            />
            <NumberInput
              id="compliance-retention"
              label="Retention (days)"
              min={1}
              max={365}
              value={retentionDays}
              onChange={(_, { value }) => setRetentionDays(Number(value) || 0)}
            />
            <NumberInput
              id="compliance-segment-length"
              label="Segment length (minutes)"
              min={5}
              max={240}
              value={segmentMinutes}
              onChange={(_, { value }) => setSegmentMinutes(Number(value) || 0)}
            />
          </div>

          {!alwaysOn && (
            <p className="settings-page__tab-copy">

            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ComplianceRecordSettings;
